import styled from 'styled-components';

import { getSpace, mq, px2rem } from '@stylesheets/tools';

const StyledArchiveContent = styled.section`
  padding-top: ${px2rem('120px')};
  min-height: 100vh;

  ${mq('m')} {
    padding-top: ${px2rem('80px')};
  }

  ${mq('l')} {
    padding-top: 0;
  }

  .archive__switch {
    display: none;
    position: fixed;
    top: ${getSpace('xxs')};
    margin: auto;
    left: 50%;
    transform: translateX(-50%);
    z-index: 98;

    ${mq('l')} {
      display: block;
    }
  }

  .archive__background {
    position: fixed;
    top: 0;
    right: 0;
    z-index: -1;

    &--list,
    &--stack {
      z-index: -100;
      width: 200vw;
      height: auto;
      transition: all 0.4s ease;
      transform: translateX(20vw);

      ${mq('m')} {
        width: 74vw;
        transform: translateX(10vw);
      }

      ${mq('xl')} {
        transform: translateY(-20%) translateX(20%);
      }
    }

    &--list {
      transform: translateY(-28vh) translateX(80vw);

      ${mq('m')} {
        transform: translateY(-34vh) translateX(0vw);
      }

      ${mq('xl')} {
        transform: translateY(-70%) translateX(24vw);
      }
    }
  }
`;

export default StyledArchiveContent;
